import { type Clip, ClipType } from '@air/api/types';
import { type AppNode } from '@air/feature-edit-canvas';

export const DEFAULT_DIMENSION = 400;
export const NODE_SPACING = 16;

export const clipToAppNode = (clip: Clip, position: { x: number; y: number } = { x: 0, y: 0 }): AppNode => {
  const width = clip.width || DEFAULT_DIMENSION;
  const height = clip.height || DEFAULT_DIMENSION;
  const fileName = clip.title || clip.importedName || '';

  if (clip.type === ClipType.video) {
    return {
      id: crypto.randomUUID(),
      type: 'video',
      position,
      style: { width, height },
      data: {
        type: 'video',
        fileName,
        media: {
          image: clip.assets?.image,
          original: clip.assets?.original,
          video: clip.assets?.original,
        },
        thumbnailUrl: clip.assets?.image,
        duration: clip.duration,
        source: 'workspace',
        assetId: clip.assetId,
        versionId: clip.id,
      },
    };
  }

  return {
    id: crypto.randomUUID(),
    type: 'image',
    position,
    style: { width, height },
    data: {
      type: 'image',
      fileName,
      media: {
        image: clip.assets?.image,
        original: clip.assets?.original,
      },
      source: 'workspace',
      assetId: clip.assetId,
      versionId: clip.id,
    },
  };
};
